import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";
import { usePipedriveStore } from "../..";
import { formatNumber, formatPrice } from "../../utils/utils";
import infoStyles from '../Info.module.css';

function SaleCompInfo({ address, salePrice, pipedriveBuyerId, buildingSize, parcelSizeAcres, zoning, className, onClick }: ISaleCompInfoProps) {
    const pipedriveStore = usePipedriveStore();
    const buyerPipedriveOrganization = useMemo(() => computed(() => pipedriveStore.organizations.find(o => o.id === pipedriveBuyerId)), []).get();

    return (
        <div className={[infoStyles.container, className].join(" ")} onClick={onClick}>
            <div className={infoStyles.title}>{address}</div>
            <div className={infoStyles.description}>
                {[
                    !!salePrice && formatPrice(salePrice),
                    buyerPipedriveOrganization?.name,
                ].filter(d => d).join(" - ")}
            </div>
            <div className={infoStyles.description}>
                {[
                    !!buildingSize && `${formatNumber(buildingSize)} Sq-Ft`,
                    !!parcelSizeAcres && `${formatNumber(parcelSizeAcres)} Acres`,
                    !!zoning && `${zoning} Zoning`,
                ].filter(d => d).join(" - ")}
            </div>
        </div>
    );
}

export interface ISaleCompInfoProps {
    address: string;
    salePrice: number;
    pipedriveBuyerId: number | null;
    buildingSize: number | null;
    parcelSizeAcres: number;
    zoning: string | null;
    className?: string;
    onClick?: () => void;
}

export default observer(SaleCompInfo);